<template>
    <div class="min-h-screen bg-gray-100">
        <!-- Page Heading -->
        <header class="bg-white" id="header">
            <div class="px-4 md:px-44 flex bg-cavilam-primary text-xs md:text-sm py-2 text-red-600">
                <div class="w-1/2 text-left text-white">
                    + 33 (0)4 70 30 83 83 | <inertia-link :href="route('contact.show')" class="hover:text-gray-200">{{ __('Contact') }}</inertia-link>
                </div>
                <div class="w-1/2 text-right text-white">
                    <language-selector></language-selector> |
                    <template v-if="$page.props && $page.props.metas">
                        <inertia-link class="font-bold hover:text-gray-300" v-if="$page.props.metas.site && $page.props.metas.site === 'dle'" :href="route('site-switcher', 'fle')">FLE</inertia-link>
                        <inertia-link v-else class="font-bold hover:text-gray-300" :href="route('site-switcher', 'dle')">DLE</inertia-link>
                    </template>
                </div>
            </div>
            <div class="px-4 md:px-44">
                <!-- Logo -->
                <inertia-link title="Cavilam" class="block w-56 m-auto hover:text-gray-200"  :href="route('accueil')">
                    <img :src="asset('images/logo.png')">
                </inertia-link>
            </div>
            <div class="px-4 md:px-44 flex bg-cavilam-primary text-xs py-2 text-white">
                <div class="w-1/2 text-left text-white"><breadcrumb></breadcrumb></div>
                <div class="w-1/2 text-right text-white">
                    <template v-if="$page.props && $page.props.metas">
                        <inertia-link class="hover:text-gray-200" :href="route('panier.index')" :title="__('panier')">
                            <i class="fas fa-shopping-cart badge" :value="$page.props.metas.nbItemPanier"></i> {{ __('panier') }}
                        </inertia-link>
                    </template>
                    |
                    <template v-if="$page.props.auth && $page.props.auth.user">
                        <inertia-link class="hover:text-gray-200" :href="route('utilisateur.index')" :title="__('mon-compte')">
                            <i class="fas fa-user"></i>
                        </inertia-link>
                         |
                        <inertia-link class="hover:text-gray-200" method="post" :href="route('logout')" as="button">
                                <i class="fas fa-sign-in-alt"></i>
                        </inertia-link>
                    </template>
                    <template v-else>
                        <inertia-link class="hover:text-gray-200" :href="route('login')" :title="__('mon-compte')">
                            <i class="fas fa-user"></i>
                        </inertia-link>
                    </template>
                </div>
            </div>

        </header>

        <!-- Page Content -->
        <main class="px-4 md:px-4 lg:px-20 py-5 bg-gray-100">
            <slot />
        </main>
    </div>
    <footer id="footer" class="bg-gray-100 p-4 md:p-22 border-t-2 border-gray-200 text-center text-cavilam-primary text-sm">
        <p>{{ __('un_probleme_contactez_nous') }}</p>
        <p>Tel: +33 4 70 30 83 83</p>
        <p>Email: <a href="mailto:info@cavilam.com">info@cavilam.com</a></p>
        <p v-html="__('telechargez_brochures')"></p>
        <p v-html="__('conditions_generales_vente')"></p>
    </footer>
</template>

<script>
import BreezeDropdownLink from '@/Components/DropdownLink'
import LanguageSelector from '@/Components/LanguageSelector'
import Breadcrumb from "@/Components/Breadcrumb";

export default {
    components: {
        Breadcrumb,
        BreezeDropdownLink,
        LanguageSelector,
    },

    data() {
        return {
            //
        }
    },
    methods: {
        track_page_view(page) {
            const path = (page.props?.metas?.breadcrumb || []).join('/');
            const locale = page.props?.metas?.locale || 'fr';

            dataLayer.push({
                event: 'page_view',
                page_language: locale,
                page_path: path,
            });
        }
    },
    watch: {
        $page: {
            handler(newPage) {
                this.track_page_view(newPage);
            },
            deep: true,
        }
    },

    mounted() {
        this.track_page_view(this.$page);
    }
}
</script>
